@if (isDataLoaded) {
<div class="main-block">
  <app-profile></app-profile>
  <app-subscription></app-subscription>
  <app-history></app-history>
  <app-topwidget></app-topwidget>
</div>
}
